<template>
  <div>
    <el-dialog
      :title="form.id ? '编辑内训' : '新建内训'"
      :visible.sync="dialogVisible"
      width="1300px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :before-close="handleClose"
    >
      <el-form :model="form" :rules="rule" ref="form">
        <el-form-item label="内训标题" :label-width="formLabelWidth" prop="name">
          <!-- <el-input
            v-model="form.name"
            autocomplete="off"
            placeholder="请输入内训标题"
          ></el-input> -->
          <QuillEditor2 v-model="form.name" placeholder="请输入内训标题"/>
        </el-form-item>
        <el-form-item label="正文" :label-width="formLabelWidth" prop="content">
          <QuillEditor v-model="form.content" v-if="dialogVisible"></QuillEditor>
        </el-form-item>
        <el-form-item label="上传附件" :label-width="formLabelWidth">
          <upload v-if="dialogVisible" v-model="form.adjunctUrl" />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="preview">预 览</el-button>
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="sure">确 定</el-button>
      </span>
    </el-dialog>
    <pre-view v-if="dialogShow" :form='form'  @close='dialogShow = false'></pre-view>
  </div>
</template>

<script>
import QuillEditor from '@/components/QuillEditor/index'
import QuillEditor2 from '@/components/QuillEditor/index2'
import Upload from '@/components/uploadFile/index'
import PreView from './preview'
import { addTrain, updateTrain } from '@/api/api'

export default {
  components: {
    QuillEditor,
    QuillEditor2,
    Upload,
    PreView
  },
  props: {
    editParams: {
      type: Object,
      default: function () {
        return {}
      },
    },
  },
  data() {
    return {
      addTrain,
      dialogShow:false,
      dialogVisible: false,
      formLabelWidth: '80px',
      form: {
        name: '',
        content: '',
        adjunctUrl: [],
      },
      rule: {
        name: [
          { required: true, message: '请输⼊标题', trigger: 'blur' }
        ],
        content: [{ required: true, message: '请输⼊内容', trigger: 'blur' }],
      },
    }
  },
  methods: {
    setOpacity(flg) {
      this.dialogVisible = flg
    },
    handleClose() {
      console.log(this.form.content)
      if(this.form.content && this.form.content !== '<p><br></p>') {
        this.$confirm('此操作将关闭弹窗, 并且不保留您的编辑记录, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.close()
        }).catch(() => {});
      } else {
        this.close()
      }
    },
    close () {
      this.dialogVisible = false
      // this.$refs['form'].clearValidate()// 清除表单验证
    },
    // 获取图片
    getPic(file) {
      this.form.adjunctUrl = JSON.stringify(file)
    },
    preview(){
      this.dialogShow = true;
    },
    sure() {
      this.$refs.form.validate(async (valid) => {
        if( valid ){
          if (this.form.name === '<p><br></p>' || this.form.content === '<p><br></p>') {
            return this.$message.error('请输入必填项')
          }
          if (this.form.id) {
            updateTrain({
              id: this.form.id,
              name: this.form.name,
              content: this.form.content,
              // adjunctUrl: JSON.stringify(this.form.adjunctUrl),
              adjunctUrl: this.form.adjunctUrl.length ? JSON.stringify(this.form.adjunctUrl) : '',
            }).then((res) => {
              let { code, message } = res
              if (code === 0) {
                this.$message.success('更新成功')
                this.$emit('success')
                this.close()
                this.form = {}
              } else {
                this.$message.error(message)
              }
            })
          } else {
            addTrain({
              ...this.form,
              adjunctUrl: this.form.adjunctUrl.length ? JSON.stringify(this.form.adjunctUrl) : '',
            }).then((res) => {
              let { code, message } = res
              if (code === 0) {
                this.$message.success('新增成功')
                this.$emit('success')
                this.close()
                this.form = {}
              } else {
                this.$message.error(message)
              }
            })
          }
        }
      })
    },
  },
  watch: {
    editParams: {
      immediate: true,
      handler(newValue, oldValue) {
        // this.dialogVisible = newValue ?? true
        this.form = newValue ? {...newValue} : {}
        this.form.adjunctUrl = newValue.adjunctUrl ? JSON.parse(newValue.adjunctUrl) : []
      },
    },
    // 获取图片
    getPic(file) {
      this.form.adjunctUrl = JSON.stringify(file)
    },
  },
}
</script>

<style lang="scss"></style>
